import {Dropdown} from './dropdown';

export const SURCHARGE_OPTIONS_FR: Dropdown<number>[] = [
  {name: 'Aucun', value: 0},
  {name: '125%', value: 0.25},
  {name: '150%', value: 0.5},
  {name: '175%', value: 0.75},
  {name: '200%', value: 1},
  {name: '225%', value: 1.25},
  {name: '250%', value: 1.5},
  {name: '275%', value: 1.75},
  {name: '300%', value: 2},
  {name: '325%', value: 2.25},
  {name: '350%', value: 2.5},
  {name: '375%', value: 2.75},
  {name: '400%', value: 3},
];

export const SURCHARGE_OPTIONS_EN: Dropdown<number>[] = [
  {name: 'None', value: 0},
  {name: '125%', value: 0.25},
  {name: '150%', value: 0.5},
  {name: '175%', value: 0.75},
  {name: '200%', value: 1},
  {name: '225%', value: 1.25},
  {name: '250%', value: 1.5},
  {name: '275%', value: 1.75},
  {name: '300%', value: 2},
  {name: '325%', value: 2.25},
  {name: '350%', value: 2.5},
  {name: '375%', value: 2.75},
  {name: '400%', value: 3},
];

export const SURCHARGE_OPTIONS = {
  en: SURCHARGE_OPTIONS_EN,
  fr: SURCHARGE_OPTIONS_FR,
};
